'use client';

import React from 'react';
import { BaseButton } from '@/app/components/buttons/BaseButton';
import CheckCircleIcon from '/public/icons/check-circle.svg';

interface SuccessModalProps {
  onClose: () => void;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({ onClose, title, description }) => {
  return (
    <div className="px-9 py-11.5 flex flex-col items-center gap-1.5 text-center max-w-113.5 max-md:px-4 max-md:pt-6 max-md:pb-4">
      <CheckCircleIcon />
      <h2 className="light text-blue-900 mt-[14px]">{title}</h2>
      <p className="text-body-regular text-grey-700 max-md:text-sm max-md:leading-[150%]">{description}</p>
      <div className="w-full mt-7.5 max-md:mt-6">
        <BaseButton
          intent="primary"
          onClick={onClose}
          size="full"
          className="max-md:h-auto max-md:min-h-10.5 max-md:whitespace-normal max-md:px-2 max-md:text-sm"
        >
          Continue
        </BaseButton>
      </div>
    </div>
  );
};
